/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/Name
 * @desc Experiment name edit form
 */

import { fieldExperimentName } from 'labstep-web/components/Experiment/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Header } from 'labstep-web/core/Header';
import type React from 'react';
import styles from './styles.module.scss';
import type { ExperimentFormShowEditNameProps } from './types';

export const ExperimentFormShowEditName: React.FC<
  ExperimentFormShowEditNameProps
> = ({ experiment }) => (
  <ShowEditText
    dataCy="components/Experiment/Form/ShowEdit/Name"
    entityName={experiment.entityName}
    entity={experiment}
    field={fieldExperimentName}
    className={styles.showEdit}
  >
    <Header isDataPublic={false} size="small" noMargin>
      {experiment.name}
    </Header>
  </ShowEditText>
);
